// import * as SwitchPrimitives from "@radix-ui/react-switch"
// import { cn } from "@shared/lib/utils"
// import * as React from "react"

// const Switch = React.forwardRef<
//   React.ElementRef<typeof SwitchPrimitives.Root>,
//   React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
// >(({ className, ...props }, ref) => (
//   <SwitchPrimitives.Root
//     className={cn(
//       "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
//       className
//     )}
//     {...props}
//     ref={ref}
//   >
//     <SwitchPrimitives.Thumb
//       className={cn(
//         "pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
//       )}
//     />
//   </SwitchPrimitives.Root>
// ))
// Switch.displayName = SwitchPrimitives.Root.displayName

// export { Switch }


// src/components/ui/Switch.tsx

// import { checkPermission } from "@core/permissions/permissionChecker";
// import * as SwitchPrimitives from "@radix-ui/react-switch";
// import { cn } from "@shared/lib/utils";
// import React, { ComponentPropsWithoutRef, ElementRef } from "react";
// import { useLocation } from "react-router-dom";

// const Switch = React.forwardRef<
//   ElementRef<typeof SwitchPrimitives.Root>,
//   ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
// >(({ className, ...props }, ref) => {
//   const location = useLocation();

//   // ===== PERMISSION CHECK =====
//   // Switch always uses "update" action (toggle/modify state)
//   const hasPermission = checkPermission(location.pathname, "update");

//   // Hide switch if no permission
//   if (!hasPermission) {
//     console.log(`🚫 Switch hidden (action: update) on route: ${location.pathname}`);
//     return null;
//   }

//   console.log(`✅ Switch shown (action: update) on route: ${location.pathname}`);
//   // ===========================

//   return (
//     <SwitchPrimitives.Root
//       className={cn(
//         "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
//         className
//       )}
//       {...props}
//       ref={ref}
//     >
//       <SwitchPrimitives.Thumb
//         className={cn(
//           "pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
//         )}
//       />
//     </SwitchPrimitives.Root>
//   );
// });

// Switch.displayName = SwitchPrimitives.Root.displayName;

// export { Switch };

// src/components/ui/Switch.tsx
// src/components/ui/Switch.tsx

import * as SwitchPrimitives from "@radix-ui/react-switch";
import { cn } from "@shared/lib/utils";
import * as React from "react";
import { useLocation } from "react-router-dom";
import { useGlobalUserPermission } from "@shared/hooks/useGlobalUserPermission";
import type { ComponentPropsWithoutRef, ElementRef } from "react";
import { checkPermission } from "@core/permissions/permissionChecker";

// ==========================================
// SWITCH COMPONENT
const Switch = React.forwardRef<
  ElementRef<typeof SwitchPrimitives.Root>,
  ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => {
  // ===== HOOKS =====
  const location = useLocation();
  const permissionData = useGlobalUserPermission();

  // ===== PERMISSION CHECK =====
  // Switch always uses "update" action (toggle/modify state)
  const hasPermission = checkPermission(
    location.pathname, 
    "update",
    permissionData
  );

  // Hide switch if no permission
  if (!hasPermission) {
    console.log(`🚫 Switch hidden (action: update) on route: ${location.pathname}`);
    return null;
  }

  console.log(`✅ Switch shown (action: update) on route: ${location.pathname}`);
  // ===========================

  // ===== RENDER =====
  return (
    <SwitchPrimitives.Root
      className={cn(
        "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
        className
      )}
      {...props}
      ref={ref}
    >
      <SwitchPrimitives.Thumb
        className={cn(
          "pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
        )}
      />
    </SwitchPrimitives.Root>
  );
});

Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
